var idp = $('#id-product-reviews').attr('idp');
$(document).ready(function() {
    $(function () {
        $.ajax({
            "url": "https://productreviews.shopifycdn.com/proxy/v4/reviews/product?callback=productCallback6628202021045&product_id="+idp+"&version=v4&shop=reebok-fitness.myshopify.com",
            "type": "get",
            "dataType": "jsonp",
            jsonpCallback: "productCallback6628202021045"
        })
        .done(function (data) {
            if (data.aggregate_rating) {
                var rating = data.aggregate_rating.replace('<script type="application/ld+json">', '');
                rating = rating.replace('</script>', '');
                rating = JSON.parse(rating);
                //console.log(rating);
                $('.review-average').text(round(rating.ratingValue));
                parseReview(data.reviews);
                addPagination(data.reviews, Math.round(rating.reviewCount/4));
            } else {
                $('.hide-when-no-review').remove();
            }
        })
        .fail(function(jqXHR, status, error) {console.log(error);})
    });

    function addPagination(data, paginateNumber){
        if (paginateNumber > 1) {
            $('#spr-pagination').append("<span data-page='1' class='spr-pagination-page active'>1</span>");
            for (var h = 2; h <= paginateNumber; h++) {
                $('#spr-pagination').append("<span data-page='"+h+"' class='spr-pagination-page'>"+h+"</span>");
            }
        } else {
            $("#id-product-reviews").addClass('nopadding');
            $('#spr-pagination').hide();
        }
    }

    function parseReview(data) {
        var el = document.createElement( 'html' );
        el.innerHTML = '<html><head><title>titleTest</title></head><body>'+data+'</body></html>';
        var reviewAll = $('div.spr-review', el);
        var i;
        for (i = 0; i < reviewAll.length; i++) {

            $('#multipleReviews').append("<div class='spr-review clearfix review_"+i+"'></div>");
            var h1 = "<div class='spr-review-header-byline'>"+reviewAll[i].children[0].children[2].innerHTML+"</div>";
            var h2 = "<div class='spr-starratings spr-review-header-starratings'>"+reviewAll[i].children[0].children[0].innerHTML+"</div>";
            var reviewsHead = h1+""+h2;

            var reviewsTtl = "<h3 class='spr-review-header-title'>"+reviewAll[i].children[0].children[1].innerHTML+"</h3>";
            var reviewsText = reviewAll[i].children[1].innerHTML;
            var findWeb = reviewsText;
            var findWhat = /\[[^]*\]/gm;
            var finalReviewText = findWeb;
            var webSource = '';
            if (findWeb.match(findWhat)) {
                var webIs = findWhat.exec(findWeb);
                var file_image = webIs[0].replace('[', '');
                file_image = file_image.replace(']', '');
                file_image = file_image.replace('y n', 'y_n');
                file_image = file_image.split(',')
                image_url = "https://cdn.shopify.com/s/files/1/0268/0818/9012/files/"+file_image[0]+".png";
                webSource = "<div class='review-src'><span>Reviewed on</span><img src='"+image_url+"'>";
                finalReviewText = findWeb.replace(webIs[0], "");
                if (file_image.length > 1 && file_image[1].replace(" ", "") == 'yes' ) {
                    finalReviewText += "<div class='yes-recom'><strong>Yes,</strong> I recommend this product.<div>"
                }
            } else {
                var image_url = "https://cdn.shopify.com/s/files/1/0268/0818/9012/files/Logo-Reebok-2020.png";
                webSource = "<div class='review-src'><span>Reviewed on</span><img src='"+image_url+"'>";
            }
            $('.review_'+i).append("<div class='spr-review-header'>"+reviewsHead+""+webSource+"</div>");
            $('.review_'+i).append("<div class='spr-review-content'>"+reviewsTtl+""+finalReviewText+"</div>");
        } 
    }

    function round(number){
        var numString = number.toString();
        var returnNumb= number;
        if (numString.length > 2) {
            if (parseInt(numString[3]) >= 5) {
                var newValue = parseInt(numString[2])+1;
                returnNumb = numString.substring(0, 2)+''+newValue;
            } else {
                returnNumb = numString.substring(0, 3);
            }
        }
        return returnNumb; 
    }

    // Call Next pagination review data
    $( "#spr-pagination" ).on( "click", '.spr-pagination-page', function() {
        var target = "#id-product-reviews";
        $(target).addClass('load');
        $('html, body').animate({
            scrollTop: $("#id-product-reviews").offset().top-110
        }, 500);
        $("#spr-pagination span").removeClass('active');
        $(this).addClass('active');
        var page = $(this).text();
        $(function () {
            $.ajax({
                "url": "https://productreviews.shopifycdn.com/proxy/v4/reviews?callback=logResult&page="+page+"&product_id="+idp+"&shop=reebok-fitness.myshopify.com",
                "type": "get",
                "dataType": "jsonp",
                jsonpCallback: "logResult"
            })
            .done(function (data) {
                $('#multipleReviews').html("");
                parseReview(data.reviews);
                $(target).removeClass('load');
            })
            .fail(function(jqXHR, status, error) {
                console.log(error);
            })
        });
    });

});